import { useSelector } from 'react-redux';
import { getMasterData } from 'reducers/masterData/MasterDataSelectors';

export const useMasterData = () => {
    const masterData = useSelector(getMasterData);

    return {
        masterData
    };
};
